<ng-select
  (ngModelChange)="changeSelectedRow($event)"
  [(ngModel)]="selectedRowUUID"
  [items]="rowData"
  [multiple]="true"
  [clearSearchOnAdd]="true"
  [closeOnSelect]="false"
  [hideSelected]="true"
  bindValue="uuid"
  appendTo="body">
  <ng-template let-clear="clear" let-item="item" ng-label-tmp>
    <span class="ng-value-label">
      {{ item.label }}
      <pt-w-help (click)="$event.stopPropagation()" [help]='item.help'></pt-w-help>
    </span>
    <span (click)="clear(item)" aria-hidden="true" class="ng-value-icon right">×</span>
  </ng-template>

  <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
    {{ item.label }}
    <pt-w-help (click)="$event.stopPropagation()" [help]='item.help'></pt-w-help>
  </ng-template>
</ng-select>
